
  import { mapMutations, mapGetters } from "vuex";
  // Use apenas funções que existem no sse.js
  import { getEventSource, on, onOpen, onError } from "@/services/sse.js";
  
  export default {
    data() {
      return {
        snackbar: false,
        timeout: 4000,
        unsubscribers: [],
      };
    },
  
    computed: {
      mensagemNova() {
        return this.MENSAGENS[0] || {};
      },
      ...mapGetters("navigation", ["ANALISTA", "VENDEDOR"]),
      ...mapGetters("alertas", ["MENSAGENS"]),
      ...mapGetters("usuario", { usuario: "getUsuario" }),
    },
  
    methods: {
      ...mapMutations("alertas", ["SET_STATUS_CONEXAO", "PUSH_MENSAGENS"]),
  
      statusConexao(val) {
        this.SET_STATUS_CONEXAO(val);
      },
  
      sub(eventName, handler) {
        // 'on' já cria a assinatura e retorna a função de unsubscrever
        const un = on(eventName || "message", (payloadOrEvent) => {
          // 'on' do sse.js já tenta parsear JSON; se não, entrega string/event
          handler(payloadOrEvent);
        });
        this.unsubscribers.push(un);
      },
    },
  
    mounted() {
      // Garante instância única por aba
      getEventSource();
  
      // Conexão
      this.unsubscribers.push(onOpen(() => this.statusConexao(true)));
      this.unsubscribers.push(onError(() => this.statusConexao(false)));
  
      // Keep-alive/ping padrão
      this.sub("message", () => this.statusConexao(true));
  
      // Forçar atualização do app
      this.sub("atualizar", () => {
        this.snackbar = true;
        this.PUSH_MENSAGENS(
          `Aplicativo será atualizado pelo desenvolvimento em 5 segundos`
        );
        setTimeout(() => this.$router.go(0), 5000);
      });
  
      // Eventos do vendedor
      if (this.VENDEDOR && this.usuario && this.usuario.id) {
        const canal = `vendedor_statusAtualizado_${this.usuario.id}`;
        this.sub(canal, (message) => {
          this.snackbar = true;
          this.PUSH_MENSAGENS(`Sua venda ${message.id_venda} mudou de status.`);
        });
      }
  
      // Eventos da análise
      if (this.ANALISTA) {
        this.sub("analise_statusAtualizado", (message) => {
          this.snackbar = true;
          this.PUSH_MENSAGENS(
            `Houve atualização no status da venda #${message.id_venda}`
          );
        });
        this.sub("analise_novaVenda", () => {
          this.snackbar = true;
          this.PUSH_MENSAGENS(`Há uma nova venda.`);
        });
        this.sub("analise_vendaEditada", () => {
          this.snackbar = true;
          this.PUSH_MENSAGENS(`Uma venda foi editada.`);
        });
      }
    },
  
    beforeDestroy() {
      if (Array.isArray(this.unsubscribers)) {
        for (const un of this.unsubscribers) {
          try {
            if (typeof un === "function") un();
          } catch (e) {
            /* noop */
          }
        }
        this.unsubscribers = [];
      }
      // EventSource é singleton por aba; não fechar aqui
    },
  };
  